<template>
	<p class="ui-text" v-html="html" v-hammer:tap="tap"></p>
</template>

<script>
// import { mapGetters } from 'vuex'
// import Hammer from 'hammerjs'
// import data_status from '@/data/status.json'
import data_cards from '@/data/data_cards'

export default {
	name: 'ui-text',
	props: {
		text: { default: '' },
		replaces: { default: Array },
		value: { default: null }
	},
	computed: {
		// ...mapGetters([ 'genre' ]),
		all_replaces() {
			let replaces = [ ...this.replaces ]

			if (this.value !== null) {
				replaces.push({ '(X)': this.value })
				replaces.push({ '(s)': this.value && this.value > 1 ? 's' : '' })
			}

			return replaces
		},
		html() {
			let html = this.text

			// REPLACES
			if (this.all_replaces) {
				this.all_replaces.forEach((r) => {
					let k = Object.keys(r)[0]
					html = html.split(k).join(r[k])
				})
			}

			// STATUS / CARD
			let matches = html.match(/\(.*?\)\[(.*?)\]/gm)
			if (matches) {
				matches.forEach((match) => {
					let m = (/\((.*?)\)\[(.*?)\]/gm).exec(match)
					if (m && m.length >= 3) {
						const type = m[2].substr(0, m[2].indexOf('-'))
						html = html.replace(match, '<span class="' + type + '" data-' + type + '="' + m[2].replace(type + '-', '') + '">' + m[1] + '</span>')
					}

				})
			}

			return html
		}
	},
	methods: {
		tap(e) {
			if (e.target.classList.contains('status')) {
				e.srcEvent.stopped = true
				// window.stopTapPropagation = true
				let s = e.target.getAttribute('data-status')
				if (s) {
					let slug = s
					let value = null
					if (s) {
						s = s.split(':')
						if (s.length > 1) {
							slug = s[0]
							value = parseInt(s[1])
						}
					}
					this.$store.dispatch('add_status_info', { status_info: { slug, value } })
				}
			}
			else if (e.target.classList.contains('card')) {
				e.srcEvent.stopped = true
				// window.stopTapPropagation = true
				let s = e.target.getAttribute('data-card')
				if (s) {
					let slug = s
					let value = null
					if (s) {
						s = s.split(':')
						if (s.length > 1) {
							slug = s[0]
							value = parseInt(s[1])
						}
					}
					let card = null
					if (value) card = data_cards.find((c) => c.type === slug && c.value === value)
					if (!card) card = data_cards.find((c) => c.type === slug)
					if (card) this.$store.dispatch('add_popup', { popup: { type: 'card', card, example: true } })
				}
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

#app.hoverable
	.ui-text
		>>> .status:hover, >>> .card:hover
			text-decoration none
		>>> .status:active, >>> .card:active
			opacity 0.5

.ui-text
	display block
	>>> .status, >>> .card
		text-decoration underline
		display inline-block
		&:active
			text-decoration none

</style>
